<template>
  <div :class="['kws-int-container', working ? 'disabled' : '']">
    <introduction
      v-if="!submitted && step === 0"
      :fsCcAttrs="introduction.fsCcAttrs"
      :headline="introduction.headline"
      :text="introduction.text"
      :img="introduction.img"
      @start="goOn"
    ></introduction>
    <question
      v-if="!submitted && !error & step > 0 && questions && step <= questions.length"
      :step="step"
      :id="questions[step - 1].id"
      :key="questions[step - 1].fsCcAttrs"
      :fsCcAttrs="questions[step - 1].fsCcAttrs"
      :total="questions.length"
      :headline="questions[step - 1].headline"
      :text="questions[step - 1].text"
      :img="questions[step - 1].img"
      :answers="questions[step - 1].answers"
      :first="!introduction"
      :last="step === questions.length"
      @go-on="goOn"
      @evaluate-result="submitVote"
    ></question>
    <result
      v-if="submitted"
      :fsCcAttrs="result.fsCcAttrs"
      :headline="result.headline"
      :text="result.text"
      :img="result.img"
      :poll-result="pollResult"
    ></result>
    <outro
      v-if="error"
      :headline="translate('errorHeadline')"
      :text="translate('errorText')"
      :img="result.img"
    ></outro>
  </div>
</template>

<script>
import Introduction from './introduction.vue';
import Question from './question.vue';
import Result from './poll-result.vue';
import Outro from './outro.vue';

export default {
  components: {
    Introduction,
    Question,
    Result,
    Outro,
  },
  data() {
    return {
      submitted: false,
      error: false,
      working: false,
      pollResult: [],
      step: 0,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    introduction: Object,
    questions: Array,
    result: Object,
  },
  methods: {
    goBack() {
      this.step -= 1;
    },
    goOn() {
      this.step += 1;
    },
    async submitVote() {
      this.working = true;

      try {
        await Promise.all(this.questions.map(async (question) => {
          const apiData = {
            pollId: `${this.id}-${question.id}`,
            title: question.text,
            pollAnswers: question.answers.options
              .filter((option) => option.selected)
              .map((option) => ({ answerId: option.id, title: option.label })),
          };
          const apiResult = await this.$http.post(
            `${this.result.apiUrl}`,
            apiData,
          );
          this.enrichQuestionWithApiResults(question, apiResult.data);
        }));

        this.setCookie();
      } catch (error) {
        this.error = true;
      }

      this.working = false;
    },
    enrichQuestionWithApiResults(question, apiResultData) {
      const pollResult = {
        pollId: apiResultData.pollId,
        title: apiResultData.title,
        pollAnswers: [],
      };

      question.answers.options.forEach((option) => {
        const answer = {
          answerId: option.id,
          average: 0,
          title: option.label,
          votes: 0,
        };
        const foundApiResult = apiResultData.pollAnswers
          .filter((apiResultAnswer) => apiResultAnswer.answerId === option.id);
        if (foundApiResult.length) {
          answer.average = foundApiResult[0].average;
          answer.votes = foundApiResult[0].votes;
        }
        pollResult.pollAnswers.push(answer);
      });
      this.pollResult.push(pollResult);
    },
    async getPollResult() {
      this.working = true;

      try {
        await Promise.all(this.questions.map(async (question) => {
          const apiResult = await this.$http.get(`${this.result.apiUrl}/${this.id}-${question.id}`);
          this.enrichQuestionWithApiResults(question, apiResult.data);
        }));
        this.submitted = true;
      } catch (error) {
        this.error = true;
      }

      this.working = false;
    },
    setCookie() {
      const cookieDate = new Date();
      cookieDate.setFullYear(cookieDate.getFullYear() + 10);
      document.cookie = `kws.quiz.${this.id}.submitted=true; expires=${cookieDate.toUTCString()};`;
      this.submitted = true;
    },
  },
  created() {
    if (!this.introduction) {
      this.step = 1;
    }
    if (document.cookie.split('; ').find((row) => row.startsWith(`kws.quiz.${this.id}.submitted`))) {
      this.getPollResult();
    }
  },
};
</script>
